<template>
    <a :href="getUrl(targetDate)" v-if="beforeFlg == false">
        <span class="num">{{ targetDate.format("D") }}</span><br>
        <span class="price">{{ bestPriceString }}</span>
    </a>
    <div v-else>
        <span class="num">{{ targetDate.format("D") }}</span><br>
        <span class="price">&nbsp;</span>
    </div>
</template>

<script>
import { ref, watchEffect } from 'vue'
export default ({
    props: {
        month_link : {type: Object, require: true},
        target_date : {type: Object, require: true},
        api_result_list: { type: Object, require: true },
    },
    emits: ['apiResultList'],
    setup (props, context) {
        let targetDate = dayjs(props.target_date.targetDate)

        // 今日より前の日付チェック
        let beforeFlg = false
        if (targetDate.isBefore(dayjs().add(-1, 'd'))) {
            beforeFlg = true
        }

        // メソッド
        const getUrl = (targetDate) => {
            let paramList = [
                props.month_link.excludeDateLink,
                "date_" + targetDate.format("YYYYMMDD"),
            ]
            paramList = paramList.filter(Boolean)
            return '/search/' + paramList.join("/")
        }

        let apiUrl = getUrl(targetDate).replace("/search/", "")
        context.emit("apiResultList", apiUrl);

        // 日付文字列の設定
        const bestPriceString = ref("読込中")
        // 監視
        watchEffect(() => {
            bestPriceString.value = props.api_result_list[apiUrl]
        })

        return {
            targetDate,
            getUrl,
            beforeFlg,
            bestPriceString
        }
    },
})
</script>